import { useMutation } from 'react-query';

const extendSessionTimeout = () => {
  // need backend changes to have viewData returned in the response's payload in order to use authFetch method
  return ADV.util.request({
    uri: 'session/renew',
    type: 'POST',
    showSpinner: false,
  });
};

export const useSessionTimeoutMutation = () => {
  return useMutation(extendSessionTimeout);
};
